module.exports = __webpack_public_path__ + "img/Superb_sword_07.2a567af5.png";